import script from "./UserProfileView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfileView.vue?vue&type=script&setup=true&lang=ts"

import "./UserProfileView.vue?vue&type=style&index=0&id=a88345de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a88345de"]])

export default __exports__